import { ref } from 'vue';

// Lets any component ask app.vue to open a specific panel (e.g. "show the
// user the Calculated panel after they explicitly asked to recompute"),
// without panel open/close state itself needing to live outside app.vue.
const panelRequest = ref(null);

export function usePanelRequests() {
  function requestPanel(id) {
    panelRequest.value = id;
  }
  return { panelRequest, requestPanel };
}
